import React from 'react';
import { Icon } from 'antd';
import { Navigation } from '../../../../features/changeMode';
import { ToggleOnlyUnreadBtn } from '../../../../features/toggleOnlyUnread';
import { ToggleViewNotification } from '../../../../features/toggleNotificationView';
import ActionBtn from '../../../../shared/ui/ActionBtn/ActionBtn';
import { IoCheckmarkDoneOutline } from 'react-icons/io5';
import styles from './Header.module.scss';

const Header = ({ actionsDisabled = false, modes }) => {
  return (
    <div className={styles.root}>
      <Navigation modes={modes} className={styles.navigation} />
      <div className={styles.actions}>
        <ToggleOnlyUnreadBtn disabled={actionsDisabled} />
        <ToggleViewNotification
          render={({ read, isReadLoading }) => (
            <ActionBtn
              tooltipProps={{ title: 'Отметить все как прочитанное' }}
              disabled={actionsDisabled}
              onClick={() => read({ markAllAsRead: true })}
            >
              <Icon
                component={isReadLoading ? undefined : IoCheckmarkDoneOutline}
                type={isReadLoading ? 'loading' : undefined}
              />
            </ActionBtn>
          )}
        />
      </div>
    </div>
  );
};

export default Header;
